var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0271 47.6373C37.1817 47.6373 47.8457 36.9733 47.8457 23.8187C47.8457 10.6641 37.1817 0.00012207 24.0271 0.00012207C10.8724 0.00012207 0.208496 10.6641 0.208496 23.8187C0.208496 36.9733 10.8724 47.6373 24.0271 47.6373Z",
    fill: "url(#paint0_linear_100_2285)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0871 10.5863H18.9775C14.4678 10.5863 10.8051 14.2491 10.8051 18.7587V28.8684C10.8051 33.378 14.4678 37.0408 18.9775 37.0408H29.0871C33.5968 37.0408 37.2596 33.378 37.2596 28.8684V18.7587C37.2596 14.2491 33.5968 10.5863 29.0871 10.5863ZM34.3061 28.879C34.3061 31.7584 31.9665 34.1085 29.0766 34.1085H18.9669C16.0875 34.1085 13.7374 31.769 13.7374 28.879V18.7693C13.7374 15.8899 16.0769 13.5398 18.9669 13.5398H29.0766C31.956 13.5398 34.3061 15.8793 34.3061 18.7693V28.879Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0269 17.0542C20.3006 17.0542 17.2625 20.0924 17.2625 23.8187C17.2625 27.545 20.3006 30.5832 24.0269 30.5832C27.7532 30.5832 30.7914 27.545 30.7914 23.8187C30.7914 20.0924 27.7532 17.0542 24.0269 17.0542ZM24.0269 27.9261C21.7615 27.9261 19.9195 26.0841 19.9195 23.8187C19.9195 21.5533 21.7615 19.7113 24.0269 19.7113C26.2923 19.7113 28.1343 21.5533 28.1343 23.8187C28.1343 26.0841 26.2923 27.9261 24.0269 27.9261Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3067 17.796C31.9299 17.6949 32.3532 17.1078 32.2522 16.4846C32.1511 15.8614 31.564 15.4381 30.9408 15.5391C30.3176 15.6401 29.8943 16.2273 29.9953 16.8505C30.0963 17.4737 30.6834 17.897 31.3067 17.796Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_100_2285",
    x1: 5.89098,
    y1: 41.9548,
    x2: 39.7398,
    y2: 8.10596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIg);
export default __webpack_public_path__ + "static/media/icon-ig.1970e746b2aef4cd0fd7b7ec1dc472f7.svg";
export { ForwardRef as ReactComponent };